import * as API from '../api/AirportApi';

export function getAirports(val) {
  return API.getAirports(val);
}
